export const windowRedirectToRazorpay = (paymentData, onPaymentCompletion) => {
    window.redirectToRzpPayment(JSON.stringify(paymentData), onPaymentCompletion);
}

export const windowGTagEvent = (eventData) => {
    window.gtag('event', 'conversion', eventData);
}